import { Button } from '@skytech/ui/Button'
import { Image } from '@skytech/ui/Image'
import InfoCircleOutlineIcon from 'mdi-react/InfoCircleOutlineIcon'
import { useDispatch, useSelector, connect } from 'react-redux'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { openModal } from '@/ducks/modalReducer'
import {
  decreaseStep,
  hideAccessorySplash,
  increaseStep,
  setScreen,
  toggleProduct,
} from '@/ducks/onboarding/onboardingActions'
import {
  displayAccessoryStepSplash,
  getAccessories,
  getDockings,
  getDoubleScreen,
  getMouseAndKeyboards,
  getScreens,
  getSelectedScreenId,
  isProductSelected,
} from '@/ducks/onboarding/onboardingSelectors'
import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'
import DisplayPortImg from '@/images/onboarding/display_port.png'
import { OnboardingNotSelectedIcon, OnboardingSelectedIcon } from '@/util/icons'

import './step-accessories-all.scss'

const StepAccessories = ({
  products,
  isProductSelected,
  toggleProduct,
  increaseStep,
  decreaseStep,
}: any) => {
  const dispatch = useDispatch()

  const displaySplash = useSelector(displayAccessoryStepSplash)
  const mouseAndKeyboards = useSelector(getMouseAndKeyboards)
  const doubleScreen = useSelector(getDoubleScreen)
  const monitors = useSelector(getScreens)
  const selectedScreenId = useSelector(getSelectedScreenId)
  const dockings = useSelector(getDockings)

  const { whiteLabel } = useAppContext()

  if (displaySplash) return <Splash />

  return (
    <div id="step-accessories-all" className="step">
      <h2 className={whiteLabel}>
        <Translation id="PC TILBEHØR" />
      </h2>

      <div className="products dockings">
        {/* @ts-ignore */}

        {dockings.map(({ id, ...restOfProps }) => (
          // @ts-ignore
          <Product
            key={id}
            toggleProduct={toggleProduct}
            isProductSelected={isProductSelected(id)}
            id={id}
            {...restOfProps}
          />
        ))}
      </div>

      <div className="products">
        {/* @ts-ignore */}
        {monitors.map(({ id, ...restOfProps }) => (
          // @ts-ignore
          <Product
            key={id}
            // @ts-ignore
            toggleProduct={id => dispatch(setScreen(id, false))}
            isProductSelected={selectedScreenId === id && !doubleScreen}
            id={id}
            double={false}
            {...restOfProps}
          />
        ))}
        {/* @ts-ignore */}
        {monitors.map(({ id, ...restOfProps }) => (
          // @ts-ignore
          <Product
            key={id}
            // @ts-ignore
            toggleProduct={id => dispatch(setScreen(id, true))}
            isProductSelected={selectedScreenId === id && doubleScreen}
            id={id}
            double={true}
            {...restOfProps}
          />
        ))}
      </div>

      <div className="products">
        {/* @ts-ignore */}
        {mouseAndKeyboards.map(({ id, ...restOfProps }) => (
          // @ts-ignore
          <Product
            key={id}
            toggleProduct={toggleProduct}
            isProductSelected={isProductSelected(id)}
            id={id}
            {...restOfProps}
          />
        ))}
      </div>

      <div className="products">
        {/* @ts-ignore */}
        {products.map(({ id, ...restOfProps }) => (
          // @ts-ignore
          <Product
            key={id}
            toggleProduct={toggleProduct}
            isProductSelected={isProductSelected(id)}
            id={id}
            {...restOfProps}
          />
        ))}
      </div>

      <div className="navigation">
        <button onClick={decreaseStep} className={whiteLabel}>
          <Translation id="Tilbake" />
        </button>

        <button onClick={increaseStep} className={whiteLabel}>
          <Translation id="Neste" />
        </button>
      </div>
    </div>
  )
}

const Splash = () => {
  const dispatch = useDispatch()
  const { whiteLabel } = useAppContext()

  return (
    <div id="step-accessories-all" className="step splash">
      <h2 className={whiteLabel}>
        <Translation id="Viktig informasjon!" />
      </h2>

      <div className="product-info">
        <Image
          alt="docking"
          src="https://dustinweb.azureedge.net/image/455697/400/320/hp-mc-hp-thunderbolt-dock-g2-w-combo-cable-dokkingstasjon.jpg"
        />

        <div className="no-break">
          <h3>
            <Translation id="DOCKING" />
          </h3>

          <p>
            <Translation id="Docking er automatisk inkludert når du bestiller" />
          </p>
        </div>
      </div>

      <div className="product-info">
        <Image
          alt="monitor"
          src="https://dustinweb.azureedge.net/image/419453/400/320/philips-brilliance-240b7qpjeb-241-1920-x-1200-1610.jpg"
        />
        <div className="no-break">
          <h3 className={whiteLabel}>
            <Translation id="SKJERMER" />
          </h3>

          <p>
            <b>
              <Translation id="Har du allerede skjerm og ikke trenger en ny?" />
              <br />
              <Translation id="Sjekk at din eksisterende skjerm har Displayport inngang eller HDMI inngang." />
            </b>
          </p>

          <ul>
            <li>
              <Translation id="Hvis din skjerm har Diplayport - eller HDMI inngang" />
            </li>

            <li>
              <Translation id="Hvis din eksisterende skjerm IKKE har noen av disse to inngangene" />
            </li>
          </ul>

          <Image src={DisplayPortImg} alt="Display Port" />
        </div>
      </div>

      <div className="navigation">
        <button onClick={() => dispatch(decreaseStep())} className={whiteLabel}>
          <Translation id="Tilbake" />
        </button>

        <button onClick={() => dispatch(hideAccessorySplash())} className={whiteLabel}>
          <Translation id="Velg tilbehør" />
        </button>
      </div>
    </div>
  )
}

const Product = ({
  id,
  name,
  stock,
  price,
  imgUrl,
  toggleProduct,
  isProductSelected,
  double,
  specs,
  description,
}: any) => {
  const { whiteLabel } = useAppContext()
  const dispatch = useDispatch()
  const { formatNumber } = useFormattedNumberWithCurrency()

  // @ts-ignore
  const showInfo = e => {
    e.stopPropagation()
    dispatch(
      // @ts-ignore
      openModal(
        <div>
          <h4>{name}</h4>
          <p>{description}</p>
        </div>
      )
    )
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      onClick={() => toggleProduct(id)}
      className={`products__product ${isProductSelected && 'selected'}`}
    >
      <h3 className={whiteLabel}>
        {double && `2 x `}
        {name}
      </h3>

      <div className="selection">
        {isProductSelected ? <OnboardingSelectedIcon /> : <OnboardingNotSelectedIcon />}
      </div>

      <Image src={imgUrl} alt="product" />

      {double && <Image src={imgUrl} alt="product" />}

      {specs && <div className="specs">{specs}</div>}

      {stock !== '' && (
        <div className="stock">
          <Translation id="Lager: {stock}" stock={<b>{stock}</b>} />
        </div>
      )}

      <div className="price">
        <Translation
          id="Pris: {price}"
          values={{ price: <b>{formatNumber({ amount: double ? price * 2 : price })}</b> }}
        />
      </div>

      {description && (
        <div className="info">
          <Button
            variant="tertiary"
            onClick={showInfo}
            Icon={<InfoCircleOutlineIcon className="mr-0" />}
          />
        </div>
      )}
    </div>
  )
}
// @ts-ignore
const mapStateToProps = state => ({
  products: getAccessories(state),
  // @ts-ignore
  isProductSelected: pid => isProductSelected(state, pid),
})

const mapDispatchToProps = {
  toggleProduct,
  increaseStep,
  decreaseStep,
}

export default connect(mapStateToProps, mapDispatchToProps)(StepAccessories)
